import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { Subject, debounceTime, takeUntil } from 'rxjs';

@Component({
	selector: 'pay-with-code',
	templateUrl: 'pay-with-code.component.html',
	styleUrls: ['./pay-with-code.component.scss'],
	standalone: false
})
export class PayWithCodeComponent implements OnDestroy {
	@Output() public onCodeChange = new EventEmitter();
	public code = new UntypedFormControl(null, [Validators.required]);
	private componentDestroyed$$ = new Subject();

	constructor () {
		this.code.valueChanges
			.pipe(takeUntil(this.componentDestroyed$$), debounceTime(10))
			.subscribe((value) => {
				this.onCodeChange.emit(value);
			});
	}

	public ngOnDestroy (): void {
		this.componentDestroyed$$.next(true);
		this.componentDestroyed$$.complete();
	}
}
